import { render, staticRenderFns } from "./Creditos.vue?vue&type=template&id=0ac7d42b&scoped=true"
import script from "./Creditos.vue?vue&type=script&lang=js"
export * from "./Creditos.vue?vue&type=script&lang=js"
import style0 from "./Creditos.vue?vue&type=style&index=0&id=0ac7d42b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac7d42b",
  null
  
)

export default component.exports